/* eslint-disable camelcase */
import { SearchService } from '../lib';
import { isFeatureEnabled } from 'configs/featureFlagConfigs';

class EntityRecordSearchService extends SearchService {
  search = (ids = {}, params = {}) => {
    delete params.context;
    if (isFeatureEnabled('useTypeBasedApi', false) && window.productSuffix) {
      const { schema_id, ...rest } = params;
      return this.dispatch('ENTITY_RECORDS_SEARCH', { id: schema_id, ...ids }, rest);
    }
    return this.dispatch('ENTITY_RECORDS_SEARCH', ids, params);
  };
}

export const entityRecordSearchService = new EntityRecordSearchService();
